import { useEffect, useRef, useState } from "react"

const ParallaxSection = ({ children, parallaxMultiplier, relativeElementId }) => {
  const [elementOffset, setElementOffset] = useState(false)
  const domRef = useRef(null)

  // TODO: need to stored scroll position in useRef and apply it when the element becomes visible to avoid jumping if the element goes from invisibile to visible

  // On page scroll adjust the position of the children elements to create a parallax effect
  useEffect(() => {
    const onScroll = () => {
      if(!domRef.current) return;

       window.requestAnimationFrame(() => {
        // Set the position the parallax effect will be relative to
        // if a relative element id isn't specified this is 0 (the top of the page)
        let relativeTop = 0;
        if (typeof relativeElementId === 'string' && relativeElementId.length > 0) {
          const relativeToElement = document.getElementById(relativeElementId);
          if (relativeToElement) {
            relativeTop = getPageBounds(relativeToElement).top;
          }
        }

        // Adjust the container element position based on the page scroll to create a parallax effect. 
        // The 'parallaxMultiplier' argument controls the strength of the effect and if it moves with or against the page scrolling
        const multiplier = (typeof parallaxMultiplier === 'number' ? parseFloat(parallaxMultiplier) : 1);
        //domRef.current.style.top = parseFloat((window.scrollY - relativeTop) * multiplier) + 'px';
        domRef.current.style.transform = 'translate3d(0, '+parseInt((window.scrollY - relativeTop) * multiplier)+'px, 0)';
        //domRef.current.style.transform = 'translateY('+parseInt((window.scrollY - relativeTop) * multiplier)+'px)';
        //domRef.current.style.transition = 'transform 100ms ease';
      });
    };
    window.addEventListener('scroll', onScroll); 
    return () => {
      window.removeEventListener('scroll', onScroll);
    }
  }, [parallaxMultiplier, relativeElementId])

  function getPageBounds(element) {
    const rect = element.getBoundingClientRect();
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    return {
      top: rect.top + scrollTop,
      left: rect.left + scrollLeft,
      width: rect.width,
      height: rect.height,
      bottom: rect.bottom + scrollTop,
      right: rect.right + scrollLeft
    };
  }

  return (
    <div ref={domRef} className={`relative`}>
      {children}
    </div>
  )
}

export default ParallaxSection;
